<script setup>
const props = defineProps({ status: Number })
</script>

<template>
  <div class="py-24 text-center">
    <h1 class="text-xl font-bold">{{ status }}: {{ $t(`.title.${status}`) }}</h1>
    <div>{{ $t(`.description.${status}`) }}</div>
  </div>
</template>

<i18n lang="yaml">
en:
  title:
    503: "Service Unavailable"
    500: "Server Error"
    404: "Page Not Found"
    403: "Forbidden"
  description:
    503: "Sorry, we are doing some maintenance. Please check back soon."
    500: "Whoops, something went wrong."
    404: "Sorry, the page you are looking for could not be found."
    403: "Sorry, you are forbidden from accessing this page."

de:
  title:
    503: "Service nicht verfügbar"
    500: "Serverfehler"
    404: "Seite nicht gefunden"
    403: "Zugriff verweigert"
  description:
    503: "Wir führen gerade Wartungsarbeiten durch. Bitte versuchen Sie es später noch einmal."
    500: "Whoops, bei Ihrer Anfrage ist etwas schiefgelaufen."
    404: "Diese Seite konnte nicht gefunden werden."
    403: "Sie sind nicht berechtigt, diese Seite zu besuchen."
</i18n>
